import React, { MouseEventHandler } from "react";

import {
  Button,
  Dialog as MUIDialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
type dialog = {
  open: boolean;
  handleOpen: MouseEventHandler;
  handleClose: MouseEventHandler;
  handleConfirm: MouseEventHandler;
  title: string;
  description: any;
  succesBtn: string;
  succesBtnClass: string;
  cancelBtn: string;
  cancelBtnClass: string;
  size?: "md" | "lg" | "sm" | "xl" | "xxl";
};
export const MessageDialog = (props: dialog) => {
  return (
    <>
      <MUIDialog
        open={props.open}
        handler={props.handleOpen}
        size={props.size ? props.size : "md"}
      >
        <DialogHeader>{props.title}</DialogHeader>
        <DialogBody
          divider
          className={` text-black ${
            props.size === "xl" ? "h-[calc(100vh-100px)] overflow-scroll" : ""
          }`}
        >
          {props.description}
        </DialogBody>
        <DialogFooter className=" space-x-2">
          <Button
            className=""
            variant="gradient"
            color="green"
            onClick={props.handleConfirm}
          >
            <span>{props.succesBtn}</span>
          </Button>
          <Button
            className={`${props.cancelBtnClass}`}
            variant="gradient"
            onClick={props.handleClose}
          >
            <span>{props.cancelBtn}</span>
          </Button>
        </DialogFooter>
      </MUIDialog>
    </>
  );
};
